import React from 'react'

/**
 * Native checkbox wrapped in a label so the visible text is the hit target.
 * If no `label` is provided, renders just the input (caller is responsible
 * for an associated label or `aria-label`).
 */
export function Checkbox({
  label,
  checked,
  defaultChecked,
  onChange,
  disabled = false,
  className = '',
  ...rest
}) {
  const input = (
    <input
      type="checkbox"
      checked={checked}
      defaultChecked={defaultChecked}
      onChange={onChange}
      disabled={disabled}
      {...rest}
    />
  )
  if (!label) return input
  const classes = ['checkbox', disabled && 'checkbox--disabled', className]
    .filter(Boolean)
    .join(' ')
  return (
    <label className={classes}>
      {input}
      <span>{label}</span>
    </label>
  )
}
